import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';

import { getReactionsQueryInfo } from './utils/data.ts';
import {
	type useReactionsDataContentQuery$data,
	type useReactionsDataContentQuery$variables,
} from './hooks/__generated__/useReactionsDataContentQuery.graphql.ts';

export function preloadPageReactions({ pageId, containerId }) {
	const { query: reactionsQuery, queryVariables } = getReactionsQueryInfo(
		false,
		pageId,
		containerId,
	);

	return queryInterop<useReactionsDataContentQuery$data, useReactionsDataContentQuery$variables>({
		query: reactionsQuery,
		variables: queryVariables,
	});
}
